import { Checkbox, Divider, message, Modal, Popover, Select, Spin } from 'antd';
import { PUBLIC_URL } from '../../__common/env';
import { FaPlus } from 'react-icons/fa6';
import { observer } from 'mobx-react-lite';
import { useMainContext } from '../../hooks/useMainContext';
import { useEffect, useState } from 'react';
import { IoCloseCircleOutline } from 'react-icons/io5';
import { FaExpandAlt } from 'react-icons/fa';
import { LuUser } from 'react-icons/lu';
import { LoadingOutlined } from '@ant-design/icons';
import ImageModel from '../WorkSpace/SelectPage/ImageModel';
import { Utils } from '../../utils/Utils';
import { tempSvgUrl } from '../../constant';
import { toJS } from 'mobx';

export default function PageMangerModel({ open, onClose }) {
    const { viewManager, closetManager, apiManager } = useMainContext();

    const [isOpen, setIsOpen] = useState(false);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [loading, setLoading] = useState(false);
    const [disableAddUser, setDisableAddUser] = useState(false);
    const [selectedPages, setSelectedPages] = useState([]);
    const [lastSelectedPage, setLastSelectedPage] = useState(null);
    const [ownersList, setOwnersList] = useState([]);

    const pdfFile = viewManager.pdfFile || closetManager.pdfBuffer;

    useEffect(() => {
        if (open && pdfFile) {
            if (!viewManager.pdfDoc) {
                Utils.readPdf(pdfFile).then((pdfDoc) => {
                    const pagesDemoList = Array.from(
                        { length: pdfDoc.numPages },
                        (_, index) => ({
                            pageNum: index + 1,
                            name: `Page ${index + 1}`,
                            imageUrl: tempSvgUrl,
                            tempUrl: true,
                        }),
                    );

                    viewManager.setUiPages(pagesDemoList);
                    viewManager.setPdfDoc(pdfDoc);
                    viewManager.renderAllPages(viewManager.pdfDoc);
                });
                return;
            }
            viewManager.renderAllPages(viewManager.pdfDoc);
        }
    }, [open, pdfFile, viewManager]);

    const recomputeOwnersList = (pageOwnersRaw, allPages) => {
        const pageToUser = {};
        pageOwnersRaw.forEach((entry) => {
            entry.pages.forEach((p) => {
                pageToUser[String(p)] = entry.user_id;
            });
        });
        const ownersMap = {};
        allPages.forEach((page) => {
            const pageNumStr = String(page.pageNum);
            const user_id = pageToUser[pageNumStr];
            if (user_id) {
                if (!ownersMap[user_id]) ownersMap[user_id] = new Set();
                ownersMap[user_id].add(pageNumStr);
            } else {
                if (!ownersMap['unassigned'])
                    ownersMap['unassigned'] = new Set();
                ownersMap['unassigned'].add(pageNumStr);
            }
        });

        // Convert to array format
        return Object.entries(ownersMap)
            .map(([user_id, pagesSet]) => ({
                user_id,
                pages: Array.from(pagesSet),
            }))
            .filter((entry) => entry.pages.length > 0);
    };

    useEffect(() => {
        setOwnersList(
            recomputeOwnersList(
                toJS(closetManager.pageOwners) || [],
                toJS(viewManager.uiPages) || [],
            ),
        );
    }, [closetManager.pageOwners, viewManager.uiPages]);

    useEffect(() => {
        if (!viewManager.projectId) {
            setDisableAddUser(true);
            return;
        }
        setDisableAddUser(false);
        const initOwners = async () => {
            if (viewManager.pageOwners.length === 0) {
                const resData = await apiManager.accessData();
                viewManager.processPageData(resData);
            }
            const owners = viewManager.usersList.filter((u) => {
                return viewManager.pageOwners.some((p) => p.user_id === u.id);
            });
            setSelectedUsers(owners);
        };

        if (viewManager.pageOwners) {
            initOwners();
        }
    }, [viewManager.pageOwners?.length, viewManager.projectId]);

    const handleExpand = (imageUrl, name, pageNum) => {
        viewManager.setModelOpen(true);
        viewManager.setImageData({ imageUrl, name, pageNum });
        if (viewManager.pdfDoc) {
            viewManager.renderPage();
        }
    };

    return (
        <Modal
            open={open}
            centered
            width={'55vw'}
            onCancel={onClose}
            footer={null}
            styles={{
                content: { padding: 0, minHeight: '60vh' }, // Targets .ant-modal-content
            }}
            closeIcon={null}>
            <div className="py-[16px] w-full h-full relative">
                <button
                    className="close_icon absolute top-[-10px] right-[-10px] z-50"
                    onClick={onClose}>
                    {/* <IoCloseCircleOutline size={24} className="text-black" /> */}
                    <img
                        src={`${PUBLIC_URL}/assets/icons/close-icon.svg`}
                        alt=""
                        style={{ width: '24px', height: '24px' }}
                    />
                </button>
                <div className="text-[16px] font-favorit border-b-[1px] border-[#D9D9D9] pb-[4px] px-[16px]">
                    Page Manager
                </div>
                <div className="px-[16px] pt-[8px]  ">
                    <h1 className="text-[16px] font-favorit">Users</h1>
                    <div className="mt-[8px] flex flex-wrap gap-[8px] max-h-[80px] overflow-y-auto pb-[8px]">
                        {selectedUsers.map((user, index) => (
                            <div
                                key={index}
                                className={`h-[32px] w-fit flex justify-center items-center border-[1px] gap-[6px] border-theme-button-bg p-[4px] px-[12px] rounded-[8px] font-favorit text-[14px] leading-[16px] font-normal transition-all duration-300 ease-in-out  bg-theme-button-bg text-[#000000] hover:bg-theme-orange-hover hover:text-white
                        `}>
                                <LuUser size={20} />
                                <p className="text-[14px] font-favorit ">
                                    {user.display_name || user.email}
                                </p>
                                <div
                                    className="cursor-pointer"
                                    onClick={() => {
                                        if (selectedUser === user.id) {
                                            setSelectedUser(null);
                                        }
                                        setSelectedUsers(
                                            selectedUsers.filter(
                                                (u) => u.id !== user.id,
                                            ),
                                        );
                                    }}>
                                    <IoCloseCircleOutline size={20} />
                                </div>
                            </div>
                        ))}

                        <Popover
                            content={
                                <PopoverContent
                                    setIsOpen={setIsOpen}
                                    setSelectedUsers={setSelectedUsers}
                                    selectedUsers={selectedUsers}
                                />
                            }
                            trigger="click"
                            // placement="bottom"
                            open={isOpen}
                            styles={{
                                body: {
                                    boxShadow:
                                        '0px 4px 16px 0px rgba(0, 0, 0, 0.16)',
                                    border: '1px solid #B6B6B6',
                                    padding: '0px',
                                    fontSize: '14px',
                                    fontWeight: '400',
                                    backgroundColor: '#E7E7E7 !important',
                                    minWidth: '220px',
                                    maxWidth: '310px',
                                    width: 'fit-content !important',
                                    marginTop: '0px',
                                    borderRadius: '8px',
                                    overflow: 'hidden',
                                },
                            }}
                            onOpenChange={(visible) => setIsOpen(visible)}>
                            <button
                                onClick={() => {}}
                                disabled={disableAddUser}
                                className={`h-[32px] w-[130px] flex justify-center items-center border-[1px] border-theme-button-bg p-[4px] px-[12px] rounded-[8px] font-favorit text-[14px] leading-[16px] font-normal transition-all duration-300 ease-in-out ${
                                    disableAddUser
                                        ? 'bg-gray-300 text-gray-500 cursor-not-allowed border-gray-300'
                                        : '  bg-theme-button-bg text-[#000000] hover:bg-theme-orange-hover hover:text-white'
                                }
                        `}>
                                <FaPlus className="mr-2 text-xl" />
                                Add User
                            </button>
                        </Popover>
                    </div>
                </div>
                <Divider className="!mt-[4px] !mb-[8px]  !border-theme-button-bg" />
                <div className="px-[16px] ">
                    <h1 className="text-[16px] font-favorit">Selected Pages</h1>
                    <div className="mt-[8px] flex flex-wrap gap-[8px] max-h-[270px] overflow-y-auto pb-[8px]">
                        {viewManager.selectedPages?.map((page, index) => (
                            <div key={index}>
                                <div
                                    onClick={(event) => {
                                        if (disableAddUser) {
                                            message.error(
                                                "The project hasn't been created yet. Please wait a moment and try again.",
                                            );
                                            return;
                                        }
                                        const pageNum = page.pageNum;
                                        const name = page.name;
                                        let updatedPages = [...selectedPages];
                                        const isAlreadySelected =
                                            updatedPages.some(
                                                (p) => p.pageNum === pageNum,
                                            );

                                        if (
                                            event.shiftKey &&
                                            lastSelectedPage !== null
                                        ) {
                                            const minPage = Math.min(
                                                lastSelectedPage,
                                                pageNum,
                                            );
                                            const maxPage = Math.max(
                                                lastSelectedPage,
                                                pageNum,
                                            );

                                            const pagesInRange =
                                                viewManager.selectedPages
                                                    .filter(
                                                        (p) =>
                                                            p.pageNum >=
                                                                minPage &&
                                                            p.pageNum <=
                                                                maxPage,
                                                    )
                                                    .map(
                                                        ({
                                                            pageNum,
                                                            name,
                                                        }) => ({
                                                            pageNum,
                                                            name,
                                                        }),
                                                    );
                                            const pageNumsSet = new Set(
                                                updatedPages.map(
                                                    (p) => p.pageNum,
                                                ),
                                            );
                                            pagesInRange.forEach((p) =>
                                                pageNumsSet.add(p.pageNum),
                                            );

                                            updatedPages =
                                                viewManager.selectedPages
                                                    .filter((p) =>
                                                        pageNumsSet.has(
                                                            p.pageNum,
                                                        ),
                                                    )
                                                    .map(
                                                        ({
                                                            pageNum,
                                                            name,
                                                        }) => ({
                                                            pageNum,
                                                            name,
                                                        }),
                                                    );
                                        } else {
                                            updatedPages = isAlreadySelected
                                                ? updatedPages.filter(
                                                      (p) =>
                                                          p.pageNum !== pageNum,
                                                  )
                                                : [
                                                      ...updatedPages,
                                                      { pageNum, name },
                                                  ];
                                            setLastSelectedPage(pageNum);
                                        }
                                        updatedPages = updatedPages.reduce(
                                            (unique, page) => {
                                                if (
                                                    !unique.some(
                                                        (p) =>
                                                            p.pageNum ===
                                                                page.pageNum &&
                                                            p.name ===
                                                                page.name,
                                                    )
                                                ) {
                                                    unique.push(page);
                                                }
                                                return unique;
                                            },
                                            [],
                                        );

                                        setSelectedPages(updatedPages);
                                    }}
                                    className="flex flex-col w-[100px] h-fit px-[12px] pt-[26px] pb-[8px] cursor-pointer justify-center items-center gap-[4px] relative border-[1px] border-theme-button-bg rounded-[8px] ">
                                    {selectedPages.some(
                                        (p) => p.pageNum == page.pageNum,
                                    ) && (
                                        <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 rounded-[8px]">
                                            <img
                                                src={`${PUBLIC_URL}/assets/img/check_icon.svg`}
                                                alt=""
                                            />
                                        </div>
                                    )}

                                    <img
                                        src={`${PUBLIC_URL}/assets/icons/page.png`}
                                        alt=""
                                        className="w-[60px] h-[60px]"
                                    />
                                    <p className="text-[14px] font-favorit ">
                                        {page.name}
                                    </p>
                                    <div
                                        className="absolute top-2 right-2 text-[16px] bg-theme-button-bg rounded-[8px] w-[24px] h-[24px] flex justify-center items-center hover:bg-theme-orange cursor-pointer hover:text-white transition-all  "
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            const uiPage =
                                                viewManager.uiPages.find(
                                                    (p) => p.name === page.name,
                                                );
                                            if (uiPage) {
                                                handleExpand(
                                                    uiPage.imageUrl,
                                                    uiPage.name,
                                                    Number(uiPage.pageNum),
                                                );
                                            }
                                        }}>
                                        <FaExpandAlt />
                                    </div>
                                </div>
                                {(() => {
                                    const user = viewManager.pageOwners.find(
                                        (u) =>
                                            u.pages.some(
                                                (p) =>
                                                    String(p) ===
                                                    String(page.pageNum),
                                            ),
                                    );
                                    const selectedUser =
                                        viewManager.usersList.find(
                                            (u) => u.id === user?.user_id,
                                        );

                                    return selectedUser?.display_name ? (
                                        <p className="text-[12px] text-gray-600 text-center mt-1">
                                            {selectedUser.display_name
                                                .charAt(0)
                                                .toUpperCase() +
                                                selectedUser.display_name.slice(
                                                    1,
                                                    10,
                                                )}
                                        </p>
                                    ) : null;
                                })()}
                            </div>
                        ))}
                    </div>
                </div>
                <Divider className="!mt-[4px] !mb-[8px]  !border-theme-button-bg" />
                <div className="px-[16px] flex gap-[8px] items-center justify-between ">
                    <p className="text-[16px] font-favorit w-fit ">
                        Change selected page owner
                    </p>
                    <div className="w-fit flex gap-[8px] ">
                        <Select
                            options={selectedUsers.map((user) => ({
                                value: user.id,
                                label: user.display_name || user.email,
                            }))}
                            value={selectedUser}
                            onChange={(e) => {
                                setSelectedUser(e);
                            }}
                            placeholder="Select User"
                            getPopupContainer={() => document.body}
                            className="!font-favorit"
                            styles={{
                                menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                }),
                                menu: (base) => ({
                                    ...base,
                                    maxHeight: '200px',
                                    overflowY: 'auto',
                                }),
                                width: '200px',
                            }}
                        />
                        <button
                            onClick={() => {
                                setSelectedUser(null);
                            }}
                            className={
                                'h-[32px] w-auto min-w-[100px] border-[1px] border-theme-button-bg p-[4px] rounded-[8px] font-favorit text-[14px] leading-[16px] font-normal bg-theme-button-bg text-[#000000] hover:bg-theme-orange-hover hover:text-white transition-all duration-300 ease-in-out }'
                            }>
                            Cancel
                        </button>
                        <button
                            onClick={async () => {
                                if (selectedUser && selectedPages.length > 0) {
                                    setLoading(true);
                                    const current =
                                        toJS(viewManager.pageOwners) || [];
                                    const allPages =
                                        toJS(viewManager.uiPages) || [];
                                    let pageToUser = [];
                                    current.forEach((entry) => {
                                        entry.pages.forEach((p) => {
                                            pageToUser[+p] = entry.user_id;
                                        });
                                    });
                                    const pagesToAssign = selectedPages.map(
                                        (p) => +p.pageNum,
                                    );
                                    pagesToAssign.forEach((pageNum) => {
                                        pageToUser[pageNum] = selectedUser;
                                    });
                                    let ownersMap = [];
                                    allPages.forEach((page) => {
                                        const pageNum = +page.pageNum;
                                        const user_id = pageToUser[pageNum];
                                        if (user_id) {
                                            if (!ownersMap[user_id])
                                                ownersMap[user_id] = [];
                                            ownersMap[user_id].push(pageNum);
                                        } else {
                                            if (!ownersMap['unassigned'])
                                                ownersMap['unassigned'] = [];
                                            ownersMap['unassigned'].push(
                                                pageNum,
                                            );
                                        }
                                    });
                                    const filtered = Object.entries(ownersMap)
                                        .map(([user_id, pages]) => ({
                                            user_id,
                                            pages,
                                        }))
                                        .filter(
                                            (entry) => entry.pages.length > 0,
                                        );

                                    viewManager.setPageOwners(filtered);
                                    await apiManager.assignPageAccess();
                                    setLoading(false);
                                    setSelectedPages([]);
                                    setSelectedUser(null);
                                    setOwnersList(filtered);
                                }
                            }}
                            className={
                                'h-[32px] w-auto min-w-[100px] border-[1px] border-theme-button-bg p-[4px] rounded-[8px] font-favorit text-[14px] leading-[16px] font-normal bg-theme-orange text-[#fff] hover:bg-theme-orange-hover hover:text-white transition-all duration-300 ease-in-out }'
                            }>
                            {loading ? (
                                <Spin
                                    indicator={<LoadingOutlined spin />}
                                    className="text-white"
                                />
                            ) : (
                                'Submit'
                            )}
                        </button>
                    </div>
                </div>
            </div>
            <ImageModel />
        </Modal>
    );
}

const PopoverContent = observer(
    ({ setIsOpen, setSelectedUsers, selectedUsers }) => {
        const { viewManager } = useMainContext();

        return (
            <div className="">
                <h1 className="text-black text-[14px] font-medium font-favorit px-3 pt-3">
                    Users List
                </h1>
                <div className="px-3 pt-1">
                    <div className="overflow-y-auto max-h-[280px] flex flex-col gap-1 font-favorit text-[14px] font-medium leading-[16px] text-[#5B5F5D] ">
                        {viewManager.usersList?.map((user, index) => (
                            <div
                                key={index}
                                className="flex items-center gap-2">
                                <Checkbox
                                    className="custom-checkbox"
                                    checked={selectedUsers.some(
                                        (u) => u.id === user.id,
                                    )}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            // Add user if checked
                                            setSelectedUsers((prev) => [
                                                ...prev,
                                                user,
                                            ]);
                                        } else {
                                            // Remove user if unchecked
                                            setSelectedUsers((prev) =>
                                                prev.filter(
                                                    (u) => u.id !== user.id,
                                                ),
                                            );
                                        }
                                    }}
                                />
                                <span>{user.email}</span>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="flex  px-3 pb-3 gap-2 mt-3 justify-end">
                    <button
                        onClick={() => {
                            setIsOpen(false);
                        }}
                        className={
                            'h-[32px] w-auto min-w-[100px] border-[1px] border-theme-button-bg p-[4px] rounded-[8px] font-favorit text-[14px] leading-[16px] font-normal bg-theme-orange text-[#fff] hover:bg-theme-orange-hover hover:text-white transition-all duration-300 ease-in-out }'
                        }>
                        Close
                    </button>
                </div>
            </div>
        );
    },
);
